import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { formatarData, formatarValor } from "../components/formatarValores";
import { useSnackbar } from "notistack";

function AprovarCompras() {
  const [compras, setCompras] = useState([]);
  const [status, setStatus] = useState("Pago"); // Estado inicial diferente de "Pago"
  const { enqueueSnackbar } = useSnackbar();
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [remover, setRemover] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/compras/`
        );
        const sortedData = response.data.sort(
          (a, b) => new Date(b.dataCompra) - new Date(a.dataCompra)
        );
        setCompras(sortedData);
      } catch (error) {
        console.error("Erro ao buscar compra:", error);
      }
    };
    fetchData();
  }, [remover]);

  useEffect(() => {
    const filterOrders = () => {
      if (!Array.isArray(compras)) {
        console.error("Compras is not an array:", compras);
        return;
      }
      let filtered = [...compras];
      if (status !== "") {
        filtered = filtered.filter((compra) => compra.status !== status);
      }
      setFilteredOrders(filtered);
    };

    filterOrders();
  }, [compras, status]);

  const aprovarCompra = (id, celular, valor, nome) => {
    const textoWA = encodeURIComponent(
      `Oi, ${nome}. Seu pagamento de R$${valor} foi aprovado.\n\n` +
        `Para baixar suas fotos, acesse: \n\nadautoaraujo.com/ar/compras\n\n` +
        `*Obrigado por sua compra!*`
    );
    const novoStatus = {
      status: "Pago",
    };
    axios
      .put(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/compras/${id}`,
        novoStatus
      )
      .then(() => {
        enqueueSnackbar("Compra aprovada.", { variant: "success" });
        setStatus(!status);
        window.location.href = `http://wa.me/${celular}?text=${textoWA}`;
      })
      .catch((error) => {
        enqueueSnackbar("Não foi possível atualizar", { variant: "error" });
        console.log(error);
      });
  };

  const removerCompra = (id) => {
    axios
      .delete(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/compras/${id}`)
      .then(() => {
        enqueueSnackbar("Compra removida.", { variant: "success" });
        setRemover(!remover);
      })
      .catch((error) => {
        enqueueSnackbar("Não foi possível remover a compra", {
          variant: "error",
        });
        console.log(error);
      });
  };

  return (
    <div className="overflow-x-auto mt-24">
      <div className="filters flex justify-between mb-6">
        <div className="ml-4 form-control">
          <label className="label">
            <span className="label-text">Ocultar status tipo</span>
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="select select-bordered w-full max-w-xs"
          >
            <option value="">Mostrar todos</option>
            <option value="Pago">Ocultar pagos</option>
            <option value="Pendente">Ocultar pendentes</option>
            <option value="Pagamento em análise">
              Ocultar pagamento em análise
            </option>
          </select>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Aprovação</th>
            <th>Nome</th>
            <th>Valor</th>
            <th>Qtd</th>
            <th>Status</th>
            <th>Data</th>
            <th>Remover</th>
            <th>ChavePix</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.map((compra, index) => (
            <tr key={compra._id} className="bg-base-100 hover:bg-base-300">
              <td className="py-3 px-5">
                <div className="flex justify-center gap-x-1">
                  <Link
                    onClick={() => {
                      aprovarCompra(
                        compra._id,
                        compra.idAtleta.celular,
                        formatarValor(compra.totalPrice),
                        compra.idAtleta.nome
                      );
                    }}
                    className="bg-green-500 hover:bg-green-900 text-white py-2 px-4 font-medium rounded-lg text-sm"
                  >
                    Aprovar
                  </Link>
                </div>
              </td>
              <td className="py-3 px-5">{compra.idAtleta.nome}</td>
              <td className="py-3 px-5">
                R$ {formatarValor(compra.totalPrice)}
              </td>
              <td className="py-3 px-5">{compra.quantity}</td>
              <td className="py-3 px-5">{compra.status}</td>
              <td className="py-3 px-5">{formatarData(compra.dataCompra)}</td>
              <td>
                <Link
                  onClick={() => {
                    removerCompra(compra._id);
                  }}
                  className="bg-red-500 hover:bg-red-900 text-white py-2 px-4 font-medium rounded-lg text-sm"
                >
                  Remover
                </Link>
              </td>
              <td className="py-3 px-5">{compra.chavePix}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AprovarCompras;
